module.exports = __webpack_public_path__ + "static/media/zocalo13.3b35fa32.jpg";